namespace GeniuzPOS.Purchase {
    export interface PoPurOrderDtRow {
        Id?: number;
        SysDocNo?: string;
        WhsId?: string;
        SupplierId?: string;
        ShopId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        LastPurUnitPrice?: number;
        Qty?: number;
        BeforeDiscAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        ItemAmt?: number;
        SalesVatTypes?: string;
        VatType?: string;
        VatCode?: string;
        VatRate?: number;
        ItemVatAmt?: number;
        ItemExVatAmt?: number;
        AlocalteDiscAmt?: number;
        ItemNetAmt?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        PrRefDocNo?: string;
        PrLineId?: number;
        QtyUse?: number;
        UseFg?: number;
        SupplItemCode?: string;
        ItemNetCostValue?: number;
    }

    export namespace PoPurOrderDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuDesc';
        export const localTextPrefix = 'Purchase.PoPurOrderDt';
        export const lookupKey = 'Purchase.PoPurOrderDt';

        export function getLookup(): Q.Lookup<PoPurOrderDtRow> {
            return Q.getLookup<PoPurOrderDtRow>('Purchase.PoPurOrderDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            WhsId = "WhsId",
            SupplierId = "SupplierId",
            ShopId = "ShopId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            LastPurUnitPrice = "LastPurUnitPrice",
            Qty = "Qty",
            BeforeDiscAmt = "BeforeDiscAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            ItemAmt = "ItemAmt",
            SalesVatTypes = "SalesVatTypes",
            VatType = "VatType",
            VatCode = "VatCode",
            VatRate = "VatRate",
            ItemVatAmt = "ItemVatAmt",
            ItemExVatAmt = "ItemExVatAmt",
            AlocalteDiscAmt = "AlocalteDiscAmt",
            ItemNetAmt = "ItemNetAmt",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            PrRefDocNo = "PrRefDocNo",
            PrLineId = "PrLineId",
            QtyUse = "QtyUse",
            UseFg = "UseFg",
            SupplItemCode = "SupplItemCode",
            ItemNetCostValue = "ItemNetCostValue"
        }
    }
}
